<template>
  <section class="table-sampler-characterization" >

    <d-form-row class="m-0 mb-1">
      <d-col cols="3">
        <label>N.º da amostra</label>
        <input
          type="text"
          class="form-control"
          placeholder="N.º da amostra"
          v-model="model.sample_no"
          required
        />
      </d-col>
      <d-col cols="2">
        <label>GHE</label>
        <input
          type="text"
          class="form-control"
          placeholder="GHE"
          v-model="model.ghe"
          required
        />
      </d-col>
      <d-col cols="7">
        <label>Supervisor</label>
        <input
          type="text"
          class="form-control"
          placeholder="Supervisor"
          v-model="model.supervisor"
          required
        />
      </d-col>
    </d-form-row>

    <d-form-row class="m-0 mb-1">
      <d-col cols="12" md="9">
        <label>Funcionário</label>
        <input
          type="text"
          class="form-control"
          placeholder="Funcionário"
          v-model="model.employee"
          required
        />
      </d-col>
      <d-col cols="12" md="3">
        <label>Registro</label>
        <input
          type="text"
          class="form-control"
          placeholder="Registro"
          v-model="model.register"
          required
        />
      </d-col>
    </d-form-row>

    <d-form-row class="m-0 mb-1">
      <d-col cols="12" md="4">
        <label>Função</label>
        <input
          type="text"
          class="form-control"
          placeholder="Função"
          v-model="model.function"
          required
        />
      </d-col>
      <d-col cols="12" md="4">
        <label>Setor</label>
        <input
          type="text"
          class="form-control"
          placeholder="Setor"
          v-model="model.sector"
          required
        />
      </d-col>
      <d-col cols="12" md="4">
        <label>Máquina/Equipamento</label>
        <input
          type="text"
          class="form-control"
          placeholder="Máquina/Equipamento"
          v-model="model.equipment"
          required
        />
      </d-col>
    </d-form-row>

    <d-form-row v-if="model.files && model.files.length" class="px-4">
      <picture v-for="(file, index) in model.files" :key="file.id">
        <i class="fas fa-trash delete-img" @click="deleteFile(index)"></i>
        <img :src="`${file.url}/?w=150&h=150`" :alt="file.name">
        <h5>{{ file.file_name }}</h5>
      </picture>
    </d-form-row>

    <d-form-row>
      <d-col>
        <vue-dropzone
          id="dropzoneFiles"
          :ref="`dropzoneFiles`"
          :useCustomSlot="true"
          :options="dropzoneOptions"
          @vdropzone-files-added="addFiles"
          @vdropzone-removed-file="removedFile"
        >
          <div class="dropzone-custom-content">
            <div class="dropzone-custom-content">
              <h5 class="m-0">Clique ou arraste os arquivos aqui</h5>
            </div>
          </div>
        </vue-dropzone>
      </d-col>
    </d-form-row>
  </section>
</template>

<script>
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import { mapActions } from 'vuex';
import { cloneDeep } from '_utils';
import Events from '_utils/events';
import vue2Dropzone from 'vue2-dropzone';
import Datepicker from '_shared/Datepicker.vue';
import SampleService from '_services/rest/modules/sample';
import { CHARACTERIZATION, _CLEAR_FILES_ } from '../SampleModel';

export default {
  name: 'sample-caracterization',
  components: {
    Datepicker,
    vueDropzone: vue2Dropzone,
  },
  props: {
    caracterization: {
      type: Object,
      default: () => CHARACTERIZATION,
    },
  },
  data() {
    return {
      dropzoneOptions: {
        url: 'https://httpbin.org/post',
        thumbnailWidth: 150,
        thumbnailHeight: 150,
        // maxFilesize: 0.5,
        uploadMultiple: true,
        addRemoveLinks: true,
        createImageThumbnails: true,
      },
    };
  },
  computed: {
    model: {
      images: [],
      get() {
        return this.caracterization || cloneDeep(CHARACTERIZATION);
      },
      set(value) {
        if (value) {
          this.$emit('update:caracterization', value);
        }
      },
    },
  },
  methods: {
    ...mapActions([
      'activeAlert',
    ]),
    async addFiles(files) {
      if (!files) return;
      this.model.images = this.model.images || [];
      for (const file of files) {
        const image = await this.readAndRotateImage(file);
        this.model.images.push(image);
      }

      this.$emit('update:model', this.model);
    },

    readAndRotateImage(file) {
      return new Promise(resolve => {
        const reader = new FileReader();
        reader.onload = async event => {
          const image = await this.rotateImage(event.target.result);
          resolve(image);
        };
        reader.readAsDataURL(file);
      });
    },

    rotateImage(dataUrl) {
      return new Promise(resolve => {
        const img = new Image();
        img.onload = () => {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');

          canvas.width = img.width;
          canvas.height = img.height;
          ctx.drawImage(img, 0, 0);

          // Get the rotated image data and create a new Blob
          const rotatedImage = canvas.toDataURL('image/jpeg', 1);
          const mime = dataUrl.match(/:(.*?);/)?.[1];
          const bstr = atob(rotatedImage.split(',')[1]);
          const u8arr = new Uint8Array(bstr.length);
          for (let i = 0; i < bstr.length; i += 1) {
            u8arr[i] = bstr.charCodeAt(i);
          }
          const filename = 'rotated.jpg';
          const file = new File([u8arr], filename, { type: mime });
          resolve(file);
        };
        img.src = dataUrl;
      });
    },

    deleteFile(index) {
      const [file] = this.model.files.splice(index, 1);
      SampleService.deleteFile(file.id)
        .then(() => {
          this.activeAlert({ message: 'Arquivo deletado com sucesso', theme: 'success' });
        });
    },
    removedFile(fileToRemove) {
      if (this.model.images) {
        const index = this.model.images.findIndex(file => file.name === fileToRemove.name);
        this.model.images.splice(index, 1);
      }
    },
  },
  mounted() {
    Events.$on(_CLEAR_FILES_, () => {
      setTimeout(() => {
        this.$refs[`dropzoneFiles_${this.index}`].removeAllFiles(true);
      }, 30);
    });
  },
};
</script>

<style lang="scss" scoped>
.table-sampler-characterization {
  label {
    margin-bottom: 0;
  }
  picture {
    margin-right: 10px;
    text-align: center;
    position: relative;
    &:hover {
      .delete-img {
        display: block;
      }
    }
    .delete-img {
      position: absolute;
      top: 5px;
      right: 5px;
      color: red;
      cursor: pointer;
      font-size: 15px;
      display: none;
    }
  }
  .vue-dropzone {
    margin-top: 10px;
    border-radius: 5px;
    border-style: dashed;
    display: flex;
    align-items: center;
    justify-content: center;
    .dz-message {
    }
  }
}

</style>
